import React from "react";
import { Box, Grid, Typography } from "@mui/material";

const QRPrint = ({ phone, name, image, handleId }) => {
    const qrWithoutExt = phone?.replace("+91", "").trim();

    return (
        <Box
            sx={{
                maxWidth: "320px",
                width: "320px",
                minHeight: "525px",
                maxHeight: "525px",
                bgcolor: "#fff",
                borderRadius: 2,
                boxShadow: 3,
                p: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "start",
                position: "relative", // make this relative so we can absolutely position inside
            }}
        >
            <Box>
                <Grid direction={"row"} container justifyContent={"center"} alignContent={"center"}>
                    <Typography variant="h5" color="primary" fontWeight={"bolder"} marginRight={1}>
                        Scan & Say
                    </Typography>
                    <img
                        src={`${process.env.REACT_APP_IMAGE}/thanq.png`}
                        alt="ThanQ Logo"
                        width={90}
                        height={25}
                    />
                </Grid>
                <hr color="black" />
                <Grid direction={"row"} container justifyContent={"center"} alignContent={"center"}>
                    <Typography variant="subtitle2" color="black" fontWeight={"bold"}>
                        Your{" "}
                        <Typography
                            color="primary"
                            sx={{ display: "inline-block" }}
                            fontWeight={"bold"}
                        >
                            Appreciation
                        </Typography>{" "}
                        Matters
                    </Typography>
                </Grid>
            </Box>

            <Box
                sx={{
                    border: "#F05513 1px solid",
                    borderRadius: 4,
                    p: 1,
                    bgcolor: "#fafafa",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    my: 4,
                }}
            >
                <img
                    src={image}
                    alt="User QR"
                    style={{ width: 250, height: 250, objectFit: "cover" }}
                />

                {handleId && (
                    <Typography
                        variant="caption"
                        sx={{
                            position: "absolute",
                            right: -10,
                            top: "50%",
                            transform: "translateY(-50%) rotate(90deg)",
                            transformOrigin: "center",
                            fontSize: "0.9rem",
                            color: "gray",
                            letterSpacing: 1,
                            whiteSpace: "nowrap",
                        }}
                    >
                        {handleId}
                    </Typography>
                )}
            </Box>

            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                }}
            >
                {name && (
                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }} color="black">
                        {name}
                    </Typography>
                )}
                {qrWithoutExt && (
                    <Typography variant="body2" color="black">
                        {`+91-${qrWithoutExt}`}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default QRPrint;
